import React from "react";
import Layout from "@/components/Layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";

const Terms = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-3xl font-bold text-center">Terms of Service</CardTitle>
          </CardHeader>
          <CardContent>
            <ScrollArea className="h-[calc(100vh-200px)] pr-4">
              <div className="space-y-6">
                <section>
                  <h2 className="text-xl font-semibold mb-4">1. Acceptance of Terms</h2>
                  <p className="text-muted-foreground">
                    By accessing and using Truth Nexus Globe AI, you agree to be bound by these Terms of Service. 
                    If you do not agree to these terms.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">2. Description of Service</h2>
                  <p className="text-muted-foreground">
                    Truth Nexus provides AI-powered tools for fact-checking, source verification,online privacy,cyber security,
                    and content analysis. Our service is designed to help users assess the credibility of 
                    information and sources.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">3. User Responsibilities</h2>
                  <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                    <li>Provide accurate and truthful information when using our services</li>
                    <li>Use the service in compliance with all applicable laws and regulations</li>
                    <li>Maintain the confidentiality of your account credentials</li>
                    <li>Not attempt to manipulate or abuse the AI analysis system</li>
                    <li>Not use the service for any illegal or unauthorized purposes</li>
                  </ul>
                </section>

            

                <section>
                  <h2 className="text-xl font-semibold mb-4">5. Limitation of Liability</h2>
                  <p className="text-muted-foreground">
                    Truth Nexus  is provided "as is" without any warranties, expressed or implied. 
                  </p>
                </section>

               

                <section>
                  <h2 className="text-xl font-semibold mb-4">7. Termination</h2>
                  <p className="text-muted-foreground">
                    We reserve the right to terminate or suspend your access to Truth Nexus 
                    immediately, without prior notice or liability, for any reason whatsoever, including 
                    without limitation if you breach these Terms.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">8. Changes to Terms</h2>
                  <p className="text-muted-foreground">
                    We reserve the right to update or change these Terms of Service at any time. Your 
                    continued use of the service following the posting of any changes constitutes 
                    acceptance of those changes.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">9. Contact Information</h2>
                  <p className="text-muted-foreground">
                    If you have any questions about these Terms of Service, please contact us at 
                    wobyebgraphlin90@gmail.com
                  </p>
                </section>

                <section className="mt-8">
                  <p className="text-sm text-muted-foreground">
                    Last updated: {new Date().toLocaleDateString()}
                  </p>
                </section>
              </div>
            </ScrollArea>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default Terms; 